// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"568":"3ad2e6cf","951":"54b7b91a"}[chunkId] + ".chunk.js";
};